import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { Logo } from "../components/Logo";
import { ReportView } from "../components/report/ReportView";
import { api } from "../lib/api";


export default function EngineDemo() {
  const [selected, setSelected] = useState<string | null>(null);
  const profiles = useQuery({ queryKey: ["demo-profiles"], queryFn: api.demoProfiles });
  const active = selected ?? profiles.data?.[0]?.id ?? null;

  const scoring = useQuery({
    queryKey: ["demo-score", active],
    queryFn: () => api.demoScore(active as string),
    enabled: Boolean(active),
  });

  return (
    <div className="min-h-screen">
      <header className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-6 py-8">
        <a href="/" className="inline-flex">
          <Logo />
        </a>
        <span className="critero-label">Motor de diagnóstico · demostración</span>
      </header>

      <main className="mx-auto max-w-6xl px-6 pb-24">
        <h1 className="max-w-prose text-h2">El motor, funcionando</h1>
        <p className="mt-4 max-w-prose text-body text-ink/80">
          Cada perfil recorre la cadena completa en el servidor: los tres instrumentos, la rueda, el
          valor movilizable, la viabilidad, las diez reglas de contradicción, las palancas, el índice de
          preparación con sus topes, las once capas avanzadas, la clasificación estratégica y el
          diagnóstico de decisión. Son los mismos casos con los que se verifica la paridad contra el
          motor original.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          {profiles.data?.map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => setSelected(p.id)}
              className={`rounded-panel border px-4 py-2 text-left transition ${
                active === p.id
                  ? "border-ink bg-ink text-paper"
                  : "border-line text-teal hover:bg-white"
              }`}
            >
              <span className="block text-caption font-medium">{p.title}</span>
              <span className={`block text-caption ${active === p.id ? "text-paper/70" : "text-ink/50"}`}>
                {p.blurb}
              </span>
            </button>
          ))}
        </div>

        <div className="mt-8">
          {scoring.isPending && <p className="text-caption text-ink/60">Calculando…</p>}
          {scoring.isError && (
            <p className="text-caption text-terracotta">No se pudo calcular el diagnóstico.</p>
          )}
          {scoring.data && <ReportView data={scoring.data} />}
        </div>

        {scoring.data && (
          <p className="mt-8 text-caption text-ink/50">
            Método {scoring.data.method_version} · scoring {scoring.data.scoring_version} · narrativa{" "}
            {scoring.data.narrative_source} · confianza del diagnóstico{" "}
            {scoring.data.decision.confidence_score}/100
          </p>
        )}
      </main>
    </div>
  );
}
